import { Box } from '@mui/material';
import { BaseAccordion } from '../../../../../Accordion/BaseAccordion';
import { ValidationBadge } from '../../ValidationBadge/ValidationBadge';
import { useMultiColumnRulesBinaryCategoriesSection } from './useMultiColumnRulesBinaryCategoriesSection';
import { MultiColumnRulesBinaryCategoriesSectionProps } from './types';
import { CategorySection } from '../MultiColumnRulesWithCategoriesSection/components/CategorySection/CategorySection';
import { SignDetectionPanel } from './components/SignDetectionPanel/SignDetectionPanel';
import './MultiColumnRulesBinaryCategoriesSection.scss';

export const MultiColumnRulesBinaryCategoriesSection = (
  props: MultiColumnRulesBinaryCategoriesSectionProps
) => {
  const { validationResult, signDetectionConfig, handleSignDetectionChange } =
    useMultiColumnRulesBinaryCategoriesSection(props);

  return (
    <BaseAccordion
      title={props.title}
      expanded={props.expanded}
      onChange={props.onChange}
      className="multiColumnRulesBinaryCategoriesSection"
      badge={<ValidationBadge validationResult={validationResult} />}
    >
      <Box>
        {/* Sign Detection Panel - Always visible at top */}
        <SignDetectionPanel
          config={signDetectionConfig}
          availableHeaders={props.availableHeaders || []}
          categories={props.categories}
          onChange={handleSignDetectionChange}
        />

        {/* Category Sections - Grid layout */}
        <Box className="categorySections">
          {props.categories.map(category => (
            <CategorySection
              key={category.id}
              category={category}
              sectionId={props.sectionId}
              templateId={props.templateId}
              instrumentType={props.instrumentType}
              availableHeaders={props.availableHeaders || []}
            />
          ))}
        </Box>
      </Box>
    </BaseAccordion>
  );
};
